/* ADD GROUPS */
export const LIST_REPORT2 = "LIST_REPORT2"
export const LIST_REPORT2_SUCCESS = "LIST_REPORT2_SUCCESS"
export const LIST_REPORT2_CLEAN = "LIST_REPORT2_CLEAN"
export const LIST_REPORT2_ERROR = "LIST_REPORT2_ERROR"
